export function setPlanCodeCookie(cname: string, cvalue: string, minutes: number, path: string) {
  const d = new Date();
  d.setTime(d.getTime() + minutes * 60 * 1000);
  const expires = 'expires=' + d.toUTCString();
  const hostname = window.location.hostname;
  const domainParts = hostname.split('.');
  const tld = domainParts.slice(-2).join('.');
  const domain = `domain=.${tld}`;
  document.cookie = `${cname}=${cvalue};${expires};path=${path};${domain}`;
}
